// extracted by mini-css-extract-plugin
export default {"userArea":"style_userArea__rEkWw"};